import { render } from "./BarcodeView.vue?vue&type=template&id=39be7e80"
import script from "./BarcodeView.vue?vue&type=script&lang=js"
export * from "./BarcodeView.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__